import React, { useState, useEffect } from "react";
import "./FatcaCRSDeclaration.modules.css";
import "./ProductSelection.modules.css";

// Sharjah images
import UAECash from "../../../../assets/images/Sharjah/Onboarding/UAECash.png";
import UAECashSelected from "../../../../assets/images/Sharjah/Onboarding/UAECashSelected.png";
import UAEMargin from "../../../../assets/images/Sharjah/Onboarding/UAEMargin.png";
import UAEMarginSelected from "../../../../assets/images/Sharjah/Onboarding/UAEMarginSelected.png";

// ADCB images
import UAECashADCB from "../../../../assets/images/ADCB/Onboarding/UAECash.png";
import UAECashSelectedADCB from "../../../../assets/images/ADCB/Onboarding/UAECashSelected.png";
import UAEMarginADCB from "../../../../assets/images/ADCB/Onboarding/UAEMargin.png";
import UAEMarginSelectedADCB from "../../../../assets/images/ADCB/Onboarding/UAEMarginSelected.png";

import money from "../../../../assets/images/Sharjah/Onboarding/money-bag.png";
import calendar from "../../../../assets/images/Sharjah/Onboarding/calendar.png";

import i18next from "i18next";
import * as Constants from "../../../../constants/Constants";
import * as Helpers from "../../../../global/Helpers";
import * as utils from "../../../../global/utils";
import { useTranslation } from "react-i18next";

const FatcaCRSDeclaration9 = (props) => {
  const { t } = useTranslation();

  return (
    <div className="FatcaCRSDeclaration">
      <div className="form-container">
        <form className="dropdown-form">
          <div className="form-group">
            <h5>{t("ProductSelection")}</h5>

            <div className="seekbar-wrapper">
              <ProductSelection
                saveKycDataAPI={props.saveKycDataAPI}
                setIsCallAPI={props.setIsCallAPI}
                IsCallAPI={props.IsCallAPI}
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

function ProductSelection(props) {
  const { t } = useTranslation();

  const [selected, setSelected] = useState("");
  const [selected2, setSelected2] = useState("");
  const [selected3, setSelected3] = useState("");
  const [selected4, setSelected4] = useState("");

  const companyName = localStorage
    .getItem(Constants.localStorageConstants.company_name)
    ?.toUpperCase();

  // حدد الصور حسب اسم الشركة
  const imgUAECash =
    selected === "1"
      ? companyName === "ADCB"
        ? UAECashSelectedADCB
        : UAECashSelected
      : companyName === "ADCB"
      ? UAECashADCB
      : UAECash;

  const imgUAEMargin =
    selected2 === "2"
      ? companyName === "ADCB"
        ? UAEMarginSelectedADCB
        : UAEMarginSelected
      : companyName === "ADCB"
      ? UAEMarginADCB
      : UAEMargin;

  const handleClick = (value) => {
    if (selected === value) setSelected("");
    else setSelected(value);
  };

  useEffect(() => {
    if (props.IsCallAPI) saveKycDataFun();
  }, [props.IsCallAPI]);

  function validateSubmit() {
    if (selected === "") {
      Helpers.errorNotify(
        t("Please fill Client Classification"),
        i18next.language
      );
      props.setIsCallAPI(false);
      return false;
    }
    return true;
  }

  const saveKycDataFun = () => {
    const result = Helpers.getScreenIdByGroupAndName("Product Selection");
    const Items = [
      { ID: "92", Value: selected !== "" ? "1" : "0" },
      { ID: "93", Value: selected2 !== "" ? "1" : "0" },
      { ID: "94", Value: selected3 !== "" ? "1" : "0" },
      { ID: "95", Value: selected4 !== "" ? "1" : "0" },
      { ID: "288", Value: result?.GROUP_ID || "" },
      { ID: "287", Value: result?.SCREEN_ID || "" },
      { ID: "258", Value: "1" },
    ];
    props.saveKycDataAPI(Items);
  };

  return (
    <div className="ProductSelection-container" style={{ marginTop: "15px" }}>
      <label htmlFor="dropdown5" className="form-label">
        {t("based_on_classification_product_selection")}
      </label>

      <div className="button-group" style={{ justifyContent: "center" }}>
        <button
          style={{ marginInline: "10px" }}
          className={`frequency-button ${selected === "1" ? "active" : ""}`}
          onClick={(e) => {
            e.preventDefault();
            handleClick("1");
          }}
        >
          <img src={imgUAECash} style={{ paddingInline: "10px" }} />
          <div>{t("uae_cash")}</div>
        </button>

        <button
          className={`frequency-button ${selected2 === "2" ? "active" : ""}`}
          onClick={(e) => {
            e.preventDefault();
            setSelected2(selected2 === "2" ? "" : "2");
          }}
        >
          <img src={imgUAEMargin} style={{ paddingInline: "10px" }} />
          <div>{t("uae_margin")}</div>
        </button>
      </div>

      <label htmlFor="dropdown5" className="form-label">
        {t("terms_and_conditions_notice")}
      </label>
    </div>
  );
}

export default FatcaCRSDeclaration9;
